export const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "S.no",
  },
  {
    id: "consultantName",
    numeric: false,
    disablePadding: true,
    label: "Consultant Name",
  },
  {
    id: "startDate",
    numeric: true,
    disablePadding: false,
    label: "Start Date",
  },
  {
    id: "endDate",
    numeric: true,
    disablePadding: false,
    label: "End Date",
  },
  {
    id: "totalAmount",
    numeric: true,
    disablePadding: false,
    label: "Total Amount(₹)",
  },
  {
    id: "totalAppointment",
    numeric: true,
    disablePadding: false,
    label: "Total Appointment",
  },
  
];
